<template>
    <div class="item-container">
        <div class="type-label">{{ state.questionType }}</div>
        <div style="width: 100%;">
            <div v-for="(item, index) in state.questionList" style="margin-bottom: 20px;display: flex;width: 100%;">

                <div class="question-container">
                    <div class="question-header">
                        <div class="question-number">{{ titleIndex + 1 }}{{ biaodian }}{{ state.caseProblem }}</div>
                        <div class="question-statistics">填写率: {{ state.dataObj.completionRate }}% / 填写人数:
                            {{ state.dataObj.validResponses }}人</div>
                    </div>
                    <div class="option-list">
                        <div class="option-box" :key="index">
                            <div class="option-item" v-for="(subItem, subIndex) in item.list">
                                <div v-if="state.questionType === '评星'">
                                    <el-rate v-model="subItem.text" disabled show-score text-color="#ff9900"
                                        score-template="{value}">
                                    </el-rate>
                                </div>
                                <!-- <div v-else class="option-text">{{ subItem.text }}</div>
                                <div class="option-stat">
                                    <span class="option-percentage">{{ subItem.percentage }}%</span>
                                    <span class="option-votes">{{ subItem.count }}人</span>
                                </div> -->
								<div v-else class="option-text">
									{{ subItem.text }}
									<span class="option-percentage">{{ subItem.percentage }}%</span>
								</div>
								<div class="option-stat">
								    {{ subItem.count }}人
								</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 统计图 -->
                <div class="echarts-new" style="width: 600px;min-height: 10px;" v-if="state.questionType === '权重评分'">
                    <div style=" width: 100%;height: 50px;display: flex;justify-content: center;">
                    <div v-for="(item, index) in state.icons" style="width: 50px;height: 50px;"
                        @click="switchChart(item.type)">
                        <el-image style="width: 50px; height: 50px"
                            :src="item.type === state.iconType ? item.selected : item.unselected" mode="aspectFit"
                            fit="fill"></el-image>
                    </div>
                </div>
                <div v-show="state.iconType === 'line'" :id="setLineID(index)" style="width: 600px;height: 300px;">
                </div>
                <div v-show="state.iconType === 'column'" :id="setColumnID(index)" style="width: 600px;height: 300px;">
                </div>
                <div v-show="state.iconType === 'ring'" :id="setRingID(index)" style="width: 600px;height: 300px;">
                </div>

            </div>
        </div>
    </div>
    </div>
</template>

<script>
import { QuestionType } from '@/components/constant.js'

export default {
    name: 'AnalysisChart',
    props: {
        dataObj: { type: Object, default: () => ({}) },
        titleIndex: { type: Number, default: 0 }
    },

    watch: {
        dataObj: {
            handler(newValue, oldVal) {
                this.state.questionType = '权重评分';
                // console.log('newValue', newValue);
                this.state.dataObj = JSON.parse(newValue.analyzer)
                this.state.caseProblem = newValue.caseProblem
                if (newValue.type === QuestionType.WRQ) {
                    // var ops = this.state.dataObj.options ? this.state.dataObj.options : {};
                    console.log('this.state.dataObj.questions', this.state.dataObj.questions);
                    for (const key in this.state.dataObj.questions) {
                        let questionItem = this.state.dataObj.questions[key];
                        var ops = this.state.dataObj.options ? this.state.dataObj.options : {};
                        ops = questionItem.distribution;
                        for (const key in ops) {
                            var item = ops[key];
                            item.text = item.score;
                            item.percentage = item.rate;
                        }


                        let oneObj = {
                            average: this.state.dataObj.average,
                            median: this.state.dataObj.median,
                            variance: this.state.dataObj.variance,
                            list: ops,
                            // 折线图
                            lineChartData: {
                                categories: ops.map(option => option.text.length > 4 ? option.text.substring(0, 4) + '...' : option.text),
                                series: [
                                    {
                                        name: "折线图",
                                        data: ops.map(option => option.count),
                                        // data: [5, 5, 5, 5, 5],
                                        color: '#3A60FF',
                                        type: 'line'
                                    }
                                ]
                            },
                            // 柱状图
                            columnChartData: {
                                categories: ops.map(option => option.text.length > 4 ? option.text.substring(0, 4) + '...' : option.text),
                                series: [
                                    {
                                        name: '',
                                        data: ops.map(option => option.count),
                                        // data: [5, 5, 5, 5, 5],
                                        color: '#3A60FF',
                                        type: 'bar'
                                    }
                                ]
                            },
                            // 饼图
                            ringChartData: {
                                series: [
                                    {
                                        data: ops.map(option => ({
                                            name: option.text.length > 4 ? option.text.substring(0, 4) + '...' : option.text,
                                            value: option.count
                                        })),
                                        type: 'pie'
                                    }
                                ]
                            }

                        }
                        this.state.questionList.push(oneObj);

                    }

                    console.log(this.state.questionList, 'this.state.questionList');

                    for (const key in this.state.questionList) {
                        var lineData = this.state.questionList[key].lineChartData.categories
                        var lineseries = this.state.questionList[key].lineChartData.series
                        var columnData = this.state.questionList[key].columnChartData.categories
                        var columnseries = this.state.questionList[key].columnChartData.series
                        var ringseries = this.state.questionList[key].ringChartData.series
                        this.upChart(key,lineData,lineseries,columnData,columnseries,ringseries);
                    }




                    // 权重评分
                }
                // 
            },
            deep: true,
            immediate: true
        }
    },
    data() {
        return {
            lineChartArray: [],
            columnChartArray: [],
            ringChartArray: [],
            biaodian: '、',
            questionList: [],

            state: {
                dataObj: {},
                caseProblem: "",
                questionList: [],
                questionType: '',
                // lineData: [],
                // lineseries: [{
                //     name: '',
                //     type: 'line',
                //     data: []
                // }],
                // columnData: [],
                // columnseries: [{
                //     name: '',
                //     type: 'bar',
                //     data: []
                // }],
                // ringData: [],
                // ringseries: [{
                //     name: '',
                //     type: 'bar',
                //     data: []
                // }],

                icons: [
                    {
                        selected: 'https://ossfastmake.mustke.com/qrCode/tupian/1744189110374.svg',
                        unselected: 'https://ossfastmake.mustke.com/qrCode/tupian/1744189084199.svg',
                        type: 'line'
                    },
                    {
                        selected: 'https://ossfastmake.mustke.com/qrCode/tupian/1744189145612.svg',
                        unselected: 'https://ossfastmake.mustke.com/qrCode/tupian/1744189130823.svg',
                        type: 'column'
                    },
                    {
                        selected: 'https://ossfastmake.mustke.com/qrCode/tupian/1744189184460.svg',
                        unselected: 'https://ossfastmake.mustke.com/qrCode/tupian/1744189163252.svg',
                        type: 'ring'
                    }
                ],
                iconType: 'line',

            }
        }
    },
    mounted() {
        if (this.dataObj.type === QuestionType.WRQ) {

            var option = {
            }

            setTimeout(() => {
                for (const index in this.state.questionList) {
                    let LineChartid = 'LineChart' + this.titleIndex + 'qz' + index;;
                    this.lineChartArray[index] = this.$echarts.init(document.getElementById(LineChartid));
                    this.lineChartArray[index].setOption(option);

                    let ColumnChartid = 'ColumnChart' + this.titleIndex + 'qz' + index;;
                    this.columnChartArray[index] = this.$echarts.init(document.getElementById(ColumnChartid));
                    this.columnChartArray[index].setOption(option);

                    let RingChartid = 'RingChart' + this.titleIndex + 'qz' + index;;
                    this.ringChartArray[index] = this.$echarts.init(document.getElementById(RingChartid));
                    this.ringChartArray[index].setOption(option);
                }


            }, 300);

        }

    },
    methods: {
        setLineID(index) {
            return 'LineChart' + this.titleIndex + 'qz' + index;
        },
        setColumnID(index) {
            return 'ColumnChart' + this.titleIndex + 'qz' + index;
        },

        setRingID(index) {
            return 'RingChart' + this.titleIndex + 'qz' + index;
        },

        upDataLine(key,lineData,lineseries) {
            var lineoption = {
                title: {   //标题组件
                    text: ''
                },
                tooltip: {}, //提示组件
                legend: {    //图例组件
                    data: ['']
                },
                xAxis: {     //x轴组件
                    data: lineData
                },
                yAxis: {},  //y轴组件
                series: lineseries
            }
            if (this.lineChartArray[key]) {

                this.lineChartArray[key].setOption(lineoption, true);

            }
        },
        upDataColumn(key,columnData,columnseries) {
            var columnoption = {
                title: {   //标题组件
                    text: ''
                },
                tooltip: {}, //提示组件
                legend: {    //图例组件
                    data: ['']
                },
                xAxis: {     //x轴组件
                    data: columnData
                },
                yAxis: {},  //y轴组件
                series: columnseries
            }
            if (this.columnChartArray[key]) {
                this.columnChartArray[key].setOption(columnoption, true);

            }
        },
        upDataRing(key,ringseries) {
            // var opinionData = this.state.ringseries
            var ringption = {
                title: {
                    text: '', // 主标题
                    subtext: '', // 副标题
                    x: 'left' // x轴方向对齐方式
                },
                // tooltip: {
                //     trigger: 'item',
                //     formatter: '{a} <br/>{b} : {c} ({d}%)'
                // },

                series: ringseries
            }
            if (this.ringChartArray[key]) {
                this.ringChartArray[key].setOption(ringption, true);

            }
        },
        upChart(key,lineData,lineseries,columnData,columnseries,ringseries) {
            if (this.dataObj.type === QuestionType.WRQ) {
                setTimeout(() => {
                    this.upDataLine(key,lineData,lineseries); this.upDataColumn(key,columnData,columnseries); this.upDataRing(key,ringseries);

                }, 500);
            }

        },
        switchChart(type) {
            this.state.iconType = type
        }
    }
}

</script>

<style scoped>
.item-container {
    background-color: #ffffff;
    width: 100%;
    /*padding: 30px;*/
    /* border-radius: 20px; */
    position: relative;
    margin: 20px;
    /*box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);*/
    display: flex;
}

.question-container {
    padding: 1rem;
    /* border: 1px solid #eee; */
    border-radius: 0.5rem;
    margin-bottom: 1rem;
    width: 600px;
    margin: 0 auto;
    margin-top: 50px;
}

.question-header {
    display: flex;
    align-items: baseline;
    margin-bottom: 0.5rem;
    color: #2c3e50;
	justify-content: space-between;
}

.question-number {
    font-weight: normal;
    font-size: 14px;
    word-break: break-all;
    font-family: auto;
    width: 400px;
}

.question-type {
    margin-right: 0.5rem;
    font-size: 14px;
}

.question-statistics {
    font-size: 12px;
    color: #666;
}

.question-input {
    margin-bottom: 1rem;
    padding: 0.8rem;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    color: #666;
    background-color: #f8f9fa;
    font-size: 14px;
}

.option-list {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.option-box {
	display: flex;
	flex-direction: column;
	gap: 10px;
}

.option-item {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.option-text {
	min-width: 550px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 10px 30px 10px 10px;
	border-radius: 4px;
	transition: all 0.3s ease;
	border: 1px solid rgba(188, 217, 255, 1);
	color: #1e80ff;
	font-size: 12px;
	position: relative;
}

.option-percentage {
	position: absolute;
	top: 50%;
	right: 10px;
	transform: translate(0%, -50%);
	color: #333;
}

.option-stat {
    display: flex;
    align-items: center;
    justify-content: flex-end;
	margin-left: 10px;
	white-space: nowrap;
	color: #333;
	font-size: 12px;
}

.chart-options {
    display: flex;
    /* justify-content: flex-end; */
    margin-top: 20rpx;
}

.type-label {
    color: #00c389;
    font-size: 16px;
    font-weight: bold;
    font-family: auto;
    background: linear-gradient(180deg, rgba(0, 179, 128, 0.11), rgba(0, 179, 128, 0.00));
    /* border-radius: 7px 0 10px 0; */
    position: absolute;
    top: -20px;
    left: -20px;
    padding: 6px 17px 18px 17px;
    margin: 20px;
}

.echarts-new {
	margin-top: 20px;
}

.echarts-new>div>div {
	width: 30px !important;
	height: 30px !important;
	cursor: pointer;
}

.echarts-new>div>div .el-image {
	width: 30px !important;
	height: 30px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/WRQAnalysisChart.vue